import {BaseService} from "@/core/services/BaseService";

class ProductBenefitService extends BaseService<any> {
  endpoint = '/product-benefit';
}

export default new ProductBenefitService();